var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConditionBased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "d808b99f49"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "358ddebdf8"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad5638f930"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 30.367188 L 135 30.367188 L 135 119.617188 L 15 119.617188 Z M 15 30.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 82,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAAA9CAAAAAAb5WHIAAAAAmJLR0QA/4ePzL8AAADNSURBVFiF7dhLDoMwDARQO8r9r+xumkI/YjzuBIEUr0AKjwEcFMVtqzBUDke8DcJgUh0jkmDGdFbEptMiNJ0XkdlIzXCEBkfQVUp5HKLJQxZTLnKRc0mXtLp/nGhmj++PVBNyoMJ3OaIpP0/oyad5+b4MPWkTyNCTdicytcLjSHXNIdfSQEaqX+WMlP119N3xxfw9fnN/VFdPx/s00SJVddhDfK+7nf/gtWlw+tKgFBOkrJjwGn5HIRGD3fjIPRmhZknipjpyY+X/9Ah7ALeQH2cT9ViHAAAAAElFTkSuQmCC",
    id: "4ff2ba20d2",
    height: 61,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "16d58578cd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#d808b99f49)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#358ddebdf8)",
    transform: "matrix(1.463415, 0, 0, 1.463115, 15, 30.365851)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 82,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAAA9CAAAAAAb5WHIAAAAAmJLR0QA/4ePzL8AAADNSURBVFiF7dhLDoMwDARQO8r9r+xumkI/YjzuBIEUr0AKjwEcFMVtqzBUDke8DcJgUh0jkmDGdFbEptMiNJ0XkdlIzXCEBkfQVUp5HKLJQxZTLnKRc0mXtLp/nGhmj++PVBNyoMJ3OaIpP0/oyad5+b4MPWkTyNCTdicytcLjSHXNIdfSQEaqX+WMlP119N3xxfw9fnN/VFdPx/s00SJVddhDfK+7nf/gtWlw+tKgFBOkrJjwGn5HIRGD3fjIPRmhZknipjpyY+X/9Ah7ALeQH2cT9ViHAAAAAElFTkSuQmCC",
    height: 61,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 82,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAAA9CAIAAACx7KlDAAAABmJLR0QA/wD/AP+gvaeTAAADTUlEQVRoge2aPU/qUBjHn1ZeSqiNiSZlIDEBBwarhsQENmLq7o6zH4CB0cnFBRcWPoCzwcHB9EM07cLSuBilgcQqJ/ZESbhDEQl6fQnP8R5v+5sobf5Pfnl6DofTCqPRCN5jMBgQQrrdbrfbffcCXDKZjPzC4uIi63LCW23f9ymlnud1Oh3W5d+ytbW1tLSUSqWYVpnV9n3f8zzTNJlW/ZgfMBenD3hwBgDTND3P832fXYlXbU6cA1ibv2pTSjlxDmBqPtYOWs2iwDyYpkkpZZE81qaU/pN5+1MYNVwEXlsd0Ol0WDRcBI5bHcBQGz2Xc8TPL/kfiWEFGYZhGIbjOACQz+d1Xdd1HSscHRztVqvVbrfT6XS5XCaEOI7TaDQsy6rVaij56CBo27bdbrdLpVKtVpNlGQAIIUdHR4Zh7O7uapo2fwl0EMa2ZVkAsL+/HzgDgCzL1Wp1copDELqt67qqqrlcbv6oHwNBW1VVVVVnvjw7OwOAjY2N+fOHw+FwOIzF0GZfQJzJJ7iue3JyYllWtVpFGdjPz8+4zoCu7bpuvV7v9XoHBwd7e3somYlEAiVnGmTter3++PjYbDY5H+qYqzTbtnu9Xrlc5twZWCxO+XcG3Jtc07TDw8P19XXETEYgj+1SqYQbyAjMm5wQYhiG67qImYzA1D49PW00Gq1WCzGTEZjam5ub6XQ6n88jZjJCGI1Gt7e3XG0Vz7C9vb2ysoKb+Qt2V9CdIdCWJAk9FwtFUVjEjrULhQKL9PlZXV1lESsCQCqV4rPh8Xh8eXmZRfL48QCfe8a5XI7R415+Hw8oisJuec/p44FkMlksFtnl4++uzI+iKMViMbi9+/0+pVSSJNyfsdhgMOCq29lsdrIVdX19Pb3CRzSPEUJ4GNiEEFmWK5XK9Bx2d3c3+fzw8ICsjZUFAIqifGuB0Ww2Xde9urpyHOf8/PyDeRt3R+2v2vF4fG1tLZlMfj1LFMWFhYVv9SSTyVxeXt7f3x8fH+/s7Myc1TTNtu2np6dEIpHNZr8e+ynCxcXF9HGhUJAkSRAE6QXEYvwg3NzcTA4CT9avwvHAO28hhoFf8MeTBZF2mIi0w0SkHSYi7TARaYeJSDtMRNphItIOE38A2m9YLRR6kq4AAAAASUVORK5CYII=",
    id: "425973f61d",
    height: 61,
    preserveAspectRatio: "xMidYMid meet"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad5638f930)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#16d58578cd)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.463415, 0, 0, 1.463115, 15, 30.365851)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 82,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAAA9CAIAAACx7KlDAAAABmJLR0QA/wD/AP+gvaeTAAADTUlEQVRoge2aPU/qUBjHn1ZeSqiNiSZlIDEBBwarhsQENmLq7o6zH4CB0cnFBRcWPoCzwcHB9EM07cLSuBilgcQqJ/ZESbhDEQl6fQnP8R5v+5sobf5Pfnl6DofTCqPRCN5jMBgQQrrdbrfbffcCXDKZjPzC4uIi63LCW23f9ymlnud1Oh3W5d+ytbW1tLSUSqWYVpnV9n3f8zzTNJlW/ZgfMBenD3hwBgDTND3P832fXYlXbU6cA1ibv2pTSjlxDmBqPtYOWs2iwDyYpkkpZZE81qaU/pN5+1MYNVwEXlsd0Ol0WDRcBI5bHcBQGz2Xc8TPL/kfiWEFGYZhGIbjOACQz+d1Xdd1HSscHRztVqvVbrfT6XS5XCaEOI7TaDQsy6rVaij56CBo27bdbrdLpVKtVpNlGQAIIUdHR4Zh7O7uapo2fwl0EMa2ZVkAsL+/HzgDgCzL1Wp1copDELqt67qqqrlcbv6oHwNBW1VVVVVnvjw7OwOAjY2N+fOHw+FwOIzF0GZfQJzJJ7iue3JyYllWtVpFGdjPz8+4zoCu7bpuvV7v9XoHBwd7e3somYlEAiVnGmTter3++PjYbDY5H+qYqzTbtnu9Xrlc5twZWCxO+XcG3Jtc07TDw8P19XXETEYgj+1SqYQbyAjMm5wQYhiG67qImYzA1D49PW00Gq1WCzGTEZjam5ub6XQ6n88jZjJCGI1Gt7e3XG0Vz7C9vb2ysoKb+Qt2V9CdIdCWJAk9FwtFUVjEjrULhQKL9PlZXV1lESsCQCqV4rPh8Xh8eXmZRfL48QCfe8a5XI7R415+Hw8oisJuec/p44FkMlksFtnl4++uzI+iKMViMbi9+/0+pVSSJNyfsdhgMOCq29lsdrIVdX19Pb3CRzSPEUJ4GNiEEFmWK5XK9Bx2d3c3+fzw8ICsjZUFAIqifGuB0Ww2Xde9urpyHOf8/PyDeRt3R+2v2vF4fG1tLZlMfj1LFMWFhYVv9SSTyVxeXt7f3x8fH+/s7Myc1TTNtu2np6dEIpHNZr8e+ynCxcXF9HGhUJAkSRAE6QXEYvwg3NzcTA4CT9avwvHAO28hhoFf8MeTBZF2mIi0w0SkHSYi7TARaYeJSDtMRNphItIOE38A2m9YLRR6kq4AAAAASUVORK5CYII=",
    height: 65,
    preserveAspectRatio: "xMidYMid meet"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionBased);
export default __webpack_public_path__ + "static/media/condition-based.f97645cb1787867a1996aa78e54f2e9b.svg";
export { ForwardRef as ReactComponent };